import type { ReactNode, SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';
import styles from './formField.module.scss';

export interface SelectFieldProps extends SelectHTMLAttributes<HTMLSelectElement> {
  /** Uppercase mono label above the select ("İLAN İLİ"). */
  label: string;
  /** Leading icon inside the box (emoji / inline SVG). */
  icon?: ReactNode;
  /** Star after the label. Opt-in: only forms that mix required and optional fields. */
  requiredMark?: boolean;
}

/** Labeled native select in the FormField visual language (create-listing il/ilçe pickers). */
export function SelectField({
  label,
  icon,
  requiredMark,
  id,
  className,
  children,
  ...rest
}: SelectFieldProps) {
  const selectId = id ?? `field-${label.replace(/\s+/g, '-').toLocaleLowerCase('tr')}`;

  return (
    <div className={`${styles.field} ${className ?? ''}`}>
      <div className={styles.labelRow}>
        <label htmlFor={selectId}>
          {label}
          {requiredMark && <span className={styles.requiredMark} aria-hidden>*</span>}
        </label>
      </div>
      <div className={styles.box}>
        {icon && (
          <span className={styles.icon} aria-hidden>
            {icon}
          </span>
        )}
        <select id={selectId} {...rest}>
          {children}
        </select>
        <span className={styles.chevron} aria-hidden>
          <ChevronDown />
        </span>
      </div>
    </div>
  );
}
